module.exports = __webpack_public_path__ + "5f0a5bfa468e960f7102e0b515a9a366.pdf";